import * as React from 'react';
import { getNotificationsApiUrl } from 'app/infrastructure/hosting';
import { UserInfo, SharedState } from 'app/types-shared';
import { Consent } from 'app/area/user-profile/my-notifications/types';
import { LayoutTranslation } from 'app/shell/constants';
import { LocationWithQuery } from 'app/components/enhancers/with-router';

interface NotificationToastProps {
  location: LocationWithQuery;
  userInfo?: UserInfo;
  consents?: Consent[];
  fetchingLoadConsents?: boolean;
  translation: LayoutTranslation;
  sharedState: SharedState;
  loadConsents: (recipientId: number) => void;
  showNotificationsToast: (translation: LayoutTranslation) => void;
}

export class NotificationToast extends React.Component<NotificationToastProps> {
  public componentDidUpdate(prevProps: NotificationToastProps) {
    const { sharedState: { showNotificationChannelsInfo }, fetchingLoadConsents, translation,
      consents, location: { pathname }, showNotificationsToast } = this.props;

    const shouldLoadConsents = !!getNotificationsApiUrl() && showNotificationChannelsInfo && !fetchingLoadConsents;

    if (pathname === '/') {
      pathname !== prevProps.location.pathname && shouldLoadConsents && this.loadConsents();
      !!consents && !consents.length && consents !== prevProps.consents && showNotificationsToast(translation);
    }
  }

  public componentDidMount() {
    this.props.sharedState.showNotificationChannelsInfo && !!getNotificationsApiUrl() && this.loadConsents();
  }

  private loadConsents = () => {
    const { loadConsents, sharedState: { id: recipientId } } = this.props;
    recipientId && loadConsents(recipientId);
  };

  public render() {
    return null;
  }
}
